<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:29:15
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-19 09:55:42
 * @Description:
-->
<template>
  <a-modal
    :width="1200"
    title="奖品设置"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="$refs.add.show(info)">新增奖品</a-button>
    </div>
    <s-table :scroll="{ x: 1200 }" ref="table" :columns="columns" rowKey="id" :data="loadData" >
      <span slot="prize_img_url" slot-scope="text">
        <a-avatar shape="square" :src="text" />
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="$refs.edit.show(record)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item
              type="error"
              @click="$refs.free.show({
                sub_id: currentRobotId,
                luckydraw_id: info.id,
                prize_id: record.id
              })"
            >口令列表</a-menu-item>
            <a-menu-item
              type="error"
              @click="handleDel(record)"
            >删除奖品</a-menu-item>
          </a-menu>
          <a>
            更多
            <a-icon type="down" />
          </a>
        </a-dropdown>
      </span>
    </s-table>
    <AddGoodsModal ref="add" @ok="$refs.table.refresh()" />
    <EditLuckyGoods ref="edit" @ok="$refs.table.refresh()" />
    <FreeDrawer ref="free" />
  </a-modal>
</template>

<script>
import { LuckyAPI } from '@/api/lucky'
import moment from 'moment'
import { STable } from '@/components'
import AddGoodsModal from '@/views/lucky/components/AddGoodsModal'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'
import EditLuckyGoods from '@/views/lucky/components/EditLuckyGoods'
import FreeDrawer from '@/views/lucky/free'

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      currentRobotId: null,
      queryParam: {},
      info: null,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        }, {
          title: '名称',
          dataIndex: 'item_name',
          ellipsis: true,
          width: 250,
          scopedSlots: { customRender: 'prize_name' }
        }, {
          title: '商品图片',
          dataIndex: 'prize_img_url',
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: 'prize_img_url' }
        }, {
          title: '价格',
          dataIndex: 'item_price',
          width: 100,
          customRender(value) {
            return `￥${value}`
          }
        }, {
          title: '数量',
          dataIndex: 'total_nums',
          width: 100,
          customRender(value) {
            return `${value}个`
          }
        }, {
          title: '中奖几率',
          dataIndex: 'prize_rate',
          width: 100,
          customRender(value) {
            return `${value}%`
          }
        }, {
          title: '所属抽奖',
          dataIndex: 'relation_to_lucky_draw.luckydraw_name',
          width: 150,
          scopedSlots: { customRender: 'luckydraw_name' }
        }, {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 200,
          scopedSlots: { customRender: 'end_time' }
        }, {
          title: '操作',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: (params) => {
        return LuckyAPI.getGoodsList({
          ...params,
          search_condition: 2,
          keywords: this.info.id,
          sub_id: this.currentRobotId
        })
      }
    }
  },
  components: {
    FreeDrawer,
    STable,
    AddGoodsModal,
    EditLuckyGoods
  },
  methods: {
    show(record) {
      this.currentRobotId = record.sub_id
      this.info = record
      this.visible = true
      this.$refs.table && this.$refs.table.refresh(true)
    },
    async handleDel(record) {
      const hide = message.loading('请稍后...')
      const [err] = await to(LuckyAPI.delLuckyGoods({
        luckydraw_id: this.info.id,
        id: record.id,
        sub_id: this.currentRobotId
      }))
      hide()
      if (!err) {
        this.$refs.table.refresh()
        return
      }
      message.error(err)
    },
    handleSelectSub() {
      this.$refs.robot.show()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.visible = false
      this.form.resetFields()
      this.$emit('ok')
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     LuckyAPI.addLucky({
      //       ...values,
      //       start_time: moment(values.start_time).format('YYYY-MM-DD') + ' 00:00:00',
      //       end_time: moment(values.end_time).format('YYYY-MM-DD') + ' 23:59:59',
      //       sub_id: this.currentRobotId
      //     }).then(res => {
      //       this.visible = false
      //       this.form.resetFields()
      //       this.$emit('ok')
      //     })
      //   }
      // })
    },
    replace(str) {
      if (str.indexOf('\\ue') !== -1) {
        // eslint-disable-next-line no-eval
        var a = str.substr(str.indexOf('\\ue'), 6)
        str = str.replace(a, eval("'" + a + "'"))
        return this.replace(str)
      } else {
        return str
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk(record) {
      this.form.setFieldsValue({
        robot_id: record.id,
        servant_id: record.servant_id
      })
    }
  }
}
</script>
